import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ClientInfoUnit.module.css';

interface ClientInfoUnitProps {
  label: string;
  value: string | number;
  isPhone?: boolean;
  isClickable?: boolean;
  onClick?: () => void;
}

const ClientInfoUnit: React.FC<ClientInfoUnitProps> = ({
  label,
  value,
  isPhone = false,
  isClickable = false,
  onClick
}) => {
  const { t } = useTranslation();

  if (isPhone) {
    return (
      <a
        href={`tel:${value}`}
        className={styles.clientInfoUnitPhone}
      >
        {t(label)}:<span>{value}</span>
      </a>
    );
  }

  if (isClickable) {
    return (
      <button
        className={styles.clientInfoUnit}
        onClick={onClick}
      >
        {t(label)}:<span>{value}</span>
      </button>
    );
  }

  return (
    <div className={styles.clientInfoUnit}>
      {t(label)}:<span>{value}</span>
    </div>
  );
};

export default ClientInfoUnit;
